let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("6J2No"), load("buDHl"), load("89pai")]).then(() => parcelRequire('j7A12'));